<p-dialog
  class="ciqual-dialog"
  (onHide)="closeDialog()"
  [dismissableMask]="true"
  [maximizable]="true"
  [contentStyle]="{'overflow':'visible'}"
  [style]="{'max-width':'600px'}"
  [(visible)]="displayDialog"
  [modal]="true"
>

  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      Recherche dans le ciqual
    </div>
  </ng-template>

  <yo-tagbox
    placeholder="Sélection des produits déclinés"
    [data]="produitsDeclines"
    [selectedItems]="selectedProduitDeclines"
    (onValueChange)="onSelectProduitsDeclines($event)">
  </yo-tagbox>

  <!--  CONTENT-->
  <yo-text-box
    id="searchTerm"
    [value]="searchTerm"
    [placeholder]="'Rechercher un plat dans le ciqual...'"
    (onValueChanged)="applyFilter($event)">
  </yo-text-box>


  <dx-data-grid
    [dataSource]="alimList"
    keyExpr="id"
    [height]="utils.getWindowAvailableHeight(400)"
    width="100%"
    [hoverStateEnabled]="true"
    [rowAlternationEnabled]="true"
    [showRowLines]="true"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [selectedRowKeys]="[]"
    #grid>

    <!--            SELECTION-->
    <dxo-selection mode="single"></dxo-selection>

    <dxi-column dataField="alim_nom_fr" caption="Nom" [width]="100"
                [allowFiltering]="false"
                [allowGrouping]="false">
    </dxi-column>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-pager
      [showPageSizeSelector]="true"
      [showNavigationButtons]="false"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} plat(s)">
    </dxo-pager>

  </dx-data-grid>

  <ng-container *ngIf="grid">
    <div *ngIf="grid.selectedRowKeys.length" class="height-40">
      <span
        class="mg-r-5">Plat sélectionné : </span><strong>{{grid.instance.getSelectedRowsData()[0].alim_nom_fr}}</strong>
    </div>

    <div *ngIf="!grid.selectedRowKeys.length" class="height-40">
    </div>

  </ng-container>


  <!--  FOOTER-->
  <ng-template pTemplate="footer">
    <div class="mg-t-10">
       <span class="mg-r-5 ">
          <yo-button
            tooltip="Importer"
            iconClass="fas fa-upload"
            [theme]="ButtonThemeEnum.DEFAULT"
            [disabled]="disabled()"
            (onClick)="savePropage()"
          ></yo-button>
        </span>
      <span class="mg-r-5">
          <yo-button
            [theme]="ButtonThemeEnum.DEFAULT"
            label="Fermer"
            (onClick)="closeDialog()"></yo-button>
        </span>
    </div>
  </ng-template>


</p-dialog>
